export default __webpack_public_path__ + "static/media/logo.acf703e4.png";